import { ApiFetcher } from 'api-fetcher-treeline/dist';

const setupApiFetcher = urlPrefix => {
	const api = new ApiFetcher(urlPrefix);

	return api;
};

const api = setupApiFetcher(`${process.env.REACT_APP_API_URL}`);

export default api;
